import { MdMic, MdMicOff } from 'react-icons/md';
import Button from '../../../buttons/button';
import { PhoneControlButtonProps } from '../types';

interface MuteButtonProps extends PhoneControlButtonProps {
  isMuted: boolean;
}

export const MuteButton: React.FC<MuteButtonProps> = ({
  onClick,
  isMuted,
  disabled,
  size = 'md',
}) => {
  return (
    <Button
      variant={isMuted ? 'danger' : 'neutral'}
      appearance="soft"
      size={size}
      onClick={onClick}
      disabled={disabled}
      className="rounded-full flex-shrink-0"
      isIconOnly
    >
      {isMuted ? (
        <MdMicOff className="w-5 h-5" />
      ) : (
        <MdMic className="w-5 h-5" />
      )}
    </Button>
  );
};
